import { Injectable, Renderer2, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  $classes = signal<string[]>(['']);

  setPageClass(classes: string|string[]){
    if (!classes) {
      this.$classes.set([]);
      return;
    }
    if (typeof classes == 'string') {
      classes = [classes];
    }
    this.$classes.set(classes);
  }
}
